import { Component,ViewChild, ElementRef, OnInit } from '@angular/core';
import { IEdificios } from '../interfaces/Edificios';
import { IFiltrosConsulta } from '../interfaces/FiltrosConsulta';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IConsultaVentasCertificadas } from '../interfaces/ConsultaVentasCertificadas';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { UsersData } from '../../applicationinfraestructure/interfaces/userData';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { environment } from '../../../environments/environment';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import Swal from 'sweetalert2';
import { CurrencyPipe, formatDate } from '@angular/common';
import { IMeses } from '../interfaces/IMeses';

@Component({
  selector: 'app-consultarventacertificada',
  templateUrl: './consultarventacertificada.component.html',
  styleUrls: ['./consultarventacertificada.component.css']
})
export class ConsultarventacertificadaComponent implements OnInit {
  @ViewChild('fileUploader') fileUploader:ElementRef;
  edificios: Array<IEdificios>;
  edificio: string;
  filtros: IFiltrosConsulta;
  formConsulta: FormGroup;
  resultadoConsulta: IConsultaVentasCertificadas[];
  submitted = false;
  error:any={isError:false,errorMessage:''};
  term: string;
  formatDate: string;
  annios: Array<number> = [];
  meses: Array<IMeses> = [];
  anio: number;
  mes: number;

  constructor(private registroServicios: RegistroVentasService,
    private readonly formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private userData: UsersData,
    private msalService: MsalUserService) {
    }

  ngOnInit(): void {
    this.getEdificiosConsulta(environment.edificiosAutorizados, environment.marcasAutorizadas);
    this.construirFromularioConsulta();
    this.cargaAnnio();
    this.cargarMeses();
    }

  construirFromularioConsulta() {
    this.formConsulta = this.formBuilder.group({
      edificio: ['', Validators.required],
      file: [null, Validators.required],
      name:[null, Validators.required],
      size:[null, Validators.required]
    });
  }

  get f() { return this.formConsulta.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.formConsulta.invalid == false && this.error.isError == true) {
      return;
    }
    else {
      this.ConsultaFiltros();
    }
  }
  

  getEdificiosConsulta(edificios: string, marcas: string) {
    this.registroServicios.getEdificiosConsulta(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve;
        }

      },
      (error: ErrorResponse) => {
        console.error(error);
       
      }
    );
  }

  ConsultaFiltros() {
    this.spinner.show();
    const filtros: IFiltrosConsulta = {
      Marcas: environment.marcasAutorizadas,
      ...this.formConsulta.value
    };
    filtros.Edificio = this.edificio;
    filtros.FechaInicio = new Date(this.anio,this.mes-1,1);
    filtros.FechaFin = new Date(this.anio,this.mes,1);
    filtros.FechaFin.setDate(0);

    this.registroServicios.getConsultaVentaCertificada(filtros).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.resultadoConsulta = resolve;
          this.resultadoConsulta.forEach(element => {
            element.Venta = +element.venta;
          });
        }
        else
        {
          Swal.fire('No se encontraron registros.');
          this.resultadoConsulta = [] ;
        }
        this.spinner.hide();

      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }


  guardarRegistroVentas(item: IConsultaVentasCertificadas){
  var registro = item;
  registro.Venta = +item.Venta;
  registro.documentos = this.formConsulta["controls"].file.value;
  registro.nombreDocumento = this.formConsulta["controls"].name.value;
  this.spinner.show();
  let result;
  if (registro.Venta != 0) {
   
    this.registroServicios.guardarRegistroVentas(registro)
      .subscribe(e => {
        result = e;
        if (result) {
          this.toaster.success('Pactia Ventas', 'Se ha guardado con éxito!.');
          this.limpiarValores();
        }
        else {
          this.toaster.warning('', 'Ya existe un registro de venta para esta marca, si quiere modificarla vaya a la opción de consulta.');
          this.limpiarValores();
        }
        this.spinner.hide();

      }, (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }

      );
  }
  else {
    this.spinner.hide();
    this.toaster.error('', 'Debe registrar la venta certificada.');

  }

}

limpiarValores() {
  this.fileUploader.nativeElement.value = '';
}

onFileChange(event) {
  const reader = new FileReader();

  if(event.target.files && event.target.files.length) {
    const [file] = event.target.files;
    reader.readAsDataURL(file);

    reader.onload = () => {
      this.formConsulta.patchValue({
        file: reader.result,
        name: file.name,
        size: file.size
     });
    
     
    };
  }
}


  compareTwoDates(){
    this.formatDate = formatDate(this.formConsulta.controls['fechaFin'].value, 'yyyy/MM/dd', 'en-US');
    var fechaInicial = formatDate(this.formConsulta.controls['fechaInicio'].value, 'yyyy/MM/dd', 'en-US')
    if(new Date(this.formatDate) < new Date(fechaInicial)){
       this.error={isError:true,errorMessage: 'La fecha no puede ser menor a la fecha inicial'};
    }
    else{
     this.error={isError:false,errorMessage: ''};
    }
 }

numberOnly(event): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

onBlurMethod(element) {

  /*if (this.ItemRegistro.Ventas !== '') {

    this.enabledButton = true;
  } else {
    this.enabledButton = false;
  }*/
  //console.log(element)
  // this.formattedAmount = this.currencyPipe.transform(this.formattedAmount, '$');

  //     element.target.value = this.formattedAmount;
}

mostrarComentario(item)
{
  if(item.comentarios != "")
  {
    Swal.fire("", item.comentarios);
  }
  else{
    Swal.fire("No hay comentarios");
  }

}
cargaAnnio() {
  var annioActual = new Date().getFullYear();

  for (let i = 2021; i <= annioActual; i++) {
    this.annios.push(i);
   
  }

}

cargarMeses(){
  this.meses.push( 
    { Value: '1', Text: 'Enero' },
    { Value: '2', Text: 'Febrero' },
    { Value: '3', Text: 'Marzo' },
    { Value: '4', Text: 'Abril' },
    { Value: '5', Text: 'Mayo' },
    { Value: '6', Text: 'Junio' },
    { Value: '7', Text: 'Julio' },
    { Value: '8', Text: 'Agosto' },
    { Value: '9', Text: 'Septiembre' },
    { Value: '10', Text: 'Octubre' },
    { Value: '11', Text: 'Noviembre' },
    { Value: '12', Text: 'Diciembre' }
  );
  
  
}

verSoporte(item){
  this.registroServicios.getSoporte(item).subscribe(
    resolve => {
      if (resolve.length != 0) {
        var urlSoporte = resolve;
      }

    },
    (error: ErrorResponse) => {
      console.error(error);
     
    }
  );
}



}

